export const env = {
    endpoint: location.protocol + '//' + window['appConfig'].endpoint.replace(/\s/g, ''),
    bidder: location.protocol + '//' + window['appConfig'].bidder.replace(/\s/g, ''),
    prefix: window['appConfig'].prefix.replace(/\s/g, ''),
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/env/index.ts